import React, { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';

const isStandalone = () =>
  window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true;

const InstallAppButton = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [guideOpen, setGuideOpen] = useState(false);

  useEffect(() => {
    const onPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
    };
    window.addEventListener('beforeinstallprompt', onPrompt);
    return () => window.removeEventListener('beforeinstallprompt', onPrompt);
  }, []);

  if (Capacitor.isNativePlatform() || isStandalone()) return null;

  const install = async () => {
    if (deferredPrompt) {
      await deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      setDeferredPrompt(null);
      return;
    }
    setGuideOpen(true);
  };

  const isiPhone = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  return (
    <>
      <button
        type="button"
        onClick={install}
        className="mx-auto mt-5 block text-xs text-indigo-200/80 hover:text-indigo-100 underline underline-offset-4"
      >
        Add TapTap to your home screen
      </button>
      {guideOpen && (
        <div className="fixed inset-0 z-dialog bg-black/80 backdrop-blur-md flex items-center justify-center p-4">
          <div className="w-full max-w-sm rounded-3xl border border-white/10 bg-slate-900 p-6 text-white shadow-2xl">
            <h2 className="text-xl font-bold">Install TapTap</h2>
            {isiPhone ? (
              <ol className="mt-4 list-decimal pl-5 space-y-2 text-sm text-gray-300">
                <li>Open this page in Safari.</li>
                <li>Tap the Share button.</li>
                <li>Choose <strong className="text-white">Add to Home Screen</strong>.</li>
                <li>Turn on <strong className="text-white">Open as Web App</strong>, then tap Add.</li>
              </ol>
            ) : (
              <ol className="mt-4 list-decimal pl-5 space-y-2 text-sm text-gray-300">
                <li>Open this page in Chrome.</li>
                <li>Open the three-dot menu.</li>
                <li>Choose <strong className="text-white">Install app</strong> or <strong className="text-white">Add to Home screen</strong>.</li>
              </ol>
            )}
            <button type="button" onClick={() => setGuideOpen(false)} className="w-full mt-6 py-3 rounded-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600">Got it</button>
          </div>
        </div>
      )}
    </>
  );
};

export default InstallAppButton;
